import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UserPreferenceKeysFragment = { __typename?: 'UserClientPreferences', hasProvidedTranscriptionDiarizationConsent: boolean, allowShareTracking: boolean, aiAssistantPromptHidden: boolean, locales?: { __typename?: 'LocalePreferences', email?: Types.SupportedLocale | null, web?: Types.SupportedLocale | null } | null };

export type UserPreferencesFragment = { __typename?: 'AuthenticatedUser', id: string, clientPreferences?: { __typename?: 'UserClientPreferences', hasProvidedTranscriptionDiarizationConsent: boolean, allowShareTracking: boolean, aiAssistantPromptHidden: boolean, locales?: { __typename?: 'LocalePreferences', email?: Types.SupportedLocale | null, web?: Types.SupportedLocale | null } | null } | null };

export const UserPreferenceKeys = /*#__PURE__*/ gql`
    fragment UserPreferenceKeys on UserClientPreferences {
  hasProvidedTranscriptionDiarizationConsent
  allowShareTracking
  aiAssistantPromptHidden
  locales {
    email
    web
  }
}
    ` as unknown as DocumentNode<UserPreferenceKeysFragment, unknown>;
export const UserPreferences = /*#__PURE__*/ gql`
    fragment UserPreferences on AuthenticatedUser {
  id
  clientPreferences {
    ...UserPreferenceKeys
  }
}
    ${UserPreferenceKeys}` as unknown as DocumentNode<UserPreferencesFragment, unknown>;

        

        
export const useUserPreferenceKeysFragment = (
  input: string | Omit<UseFragmentOptions<UserPreferenceKeysFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'UserClientPreferences' } };
    return input;
  })();

  return useFragment<UserPreferenceKeysFragment>({
    fragment: UserPreferenceKeys,
    fragmentName: 'UserPreferenceKeys',
    ...options,
  });
};
  
        
        

        
export const useUserPreferencesFragment = (
  input: string | Omit<UseFragmentOptions<UserPreferencesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AuthenticatedUser' } };
    return input;
  })();

  return useFragment<UserPreferencesFragment>({
    fragment: UserPreferences,
    fragmentName: 'UserPreferences',
    ...options,
  });
};
  
        